import sanitationRankStatistic from '@/pages/sanitationManage/sanitationRankStatistic.vue';
import sanitationRate from '@/pages/sanitationManage/sanitationRate.vue';
import sanitationQuery from '@/pages/sanitationManage/sanitationQuery.vue';
export default {
    menuName: '卫生管理',
    path: '/wsgl',
    children: [{
            path: 'wspj',
            menuName: '宿舍卫生评级',
            component: sanitationRate,
        }, {
            path: 'pmtj',
            menuName: '卫生排名统计',
            component: sanitationRankStatistic,
        }, {
            path: 'wscx',
            menuName: '宿舍卫生查询',
            component: sanitationQuery,
        }],
    component: (resolve) => require(['@/pages/sanitationManage/index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/modules/sanitationManage.js